import gsap from 'gsap';

export function select(page) {
	const target = document.getElementById('stickyBox');
	let num;
	let numLong;
	let targetHHH;
	let targetOff;
	let all;
	let sa;
	let percent;
	const heightBox = Array.from(target.getElementsByClassName("heightBox"));



	/*--------------------------------
	stickyBox
	--------------------------------*/

	//window.dispatchEvent(new Event('resize'))


	//固定化うごかないから、stickyで
	// gsap.to('.heightContainer', {
	//	 scrollTrigger: {
	//		 trigger: '.heightContainer',
	//		 start: 'bottom 100%',
	//		 end: 'bottom 100%',
	//		 endTrigger: '#stickyBox',
	//		 pin: true,
	//		 markers: true
	//	 }
	// });



	/*--------------------------------
	wantBox
	--------------------------------*/

	const wantLine = Array.from(document.getElementsByClassName("wantLine"));

	wantLine.forEach((element) => {
		//console.log(element);
		let content = element.innerHTML;
		element.innerHTML = content + content + content;
	});

	let wantEach = document.querySelectorAll(".wantLine li");
	//console.log(wantEach);
	let loopSpeed = 20;
	let maxRandom = 100;
	let minRandom = -100;
	let kyori;
	let delayTime = 0;
	let maxRandomDealy = 0.6;
	let minRandomDelay = 0;

	let randomFlg = true;
	let loopFlg = false;

	let tl1 = gsap.timeline({ repeat: -1 });
	let tl2 = gsap.timeline({ repeat: -1 });
	let tl3 = [];

	function wantSet() {
		/*--------------------------------
		サムネイルを増やす
		--------------------------------*/
	
	
		const wantLineLists = Array.from(document.getElementsByClassName('wantLine'));
		//console.log(workThumLists);
	
		wantLineLists.forEach((element) => {
			//console.log(element);
			let content = element.innerHTML;
			element.innerHTML = content + content;
		});


/*
		tl1.from(".wantLoop1", 0, {
			xPercent: -200,
			ease: 'none',
		}).to(".wantLoop1", loopSpeed, {
			xPercent: -300,
			ease: 'none',
		});
*/
		tl1.fromTo(".wantLoop1",{
			xPercent: 0,
			ease: 'none',
			duration: 20,
		},
		{
			xPercent: -100,
			ease: 'none',
			duration: 20,
		});


/*
		tl2.from(".wantLoop2", 0, {
			xPercent: 0,
			ease: 'none',
		}).to(".wantLoop2", loopSpeed, {
			xPercent: -100,
			ease: 'none',
		});
*/

		tl2.fromTo(".wantLoop2",{
			xPercent: -100,
			ease: 'none',
			duration: 20,
		},
		{
			xPercent: 0,
			ease: 'none',
			duration: 20,
		});


		tl1.pause();
		tl2.pause();

		wantEach = document.querySelectorAll(".wantLine li");

		for (var n = 0; n < wantEach.length; n++) {
			kyori = Math.random() * (maxRandom - minRandom) + minRandom;
			kyori = kyori * 1.4;

			tl3[n] = gsap.timeline();
			tl3[n].add(gsap.set(wantEach[n],
				{
					xPercent: kyori,
					opacity: 0,
				},
			));
		}

		wantRandom();
	}
	wantSet();

	function wantRandom() {
		//randomFlg = true;
		//console.log(wantEach);

		wantEach = document.querySelectorAll(".wantLine li");

		for (var k = 0; k < wantEach.length; k++) {

			kyori = Math.random() * (maxRandom - minRandom) + minRandom;
			kyori = kyori * 1.4;

			delayTime = Math.random() * (maxRandomDealy - minRandomDelay) + minRandomDelay;
			delayTime = delayTime + 0.03 * k;

			tl1.pause();
			tl2.pause();
			tl3[k].clear();
			tl3[k].add(gsap.to(wantEach[k],
				{
					xPercent: kyori,
					opacity: 0,
					duration: 0.6,
					delay: delayTime
				}
			));

			//wantEach.eq(k).css( { transform: "translateX(" + kyori + "%)" } );
		}
	}
	//wantRandom();

	let maxDelay = 0;

	function wantAdjust() {
		//randomFlg = false;

		maxDelay = 0;

		for (var m = 0; m < wantEach.length; m++) {
			delayTime = Math.random() * (maxRandomDealy - minRandomDelay) + minRandomDelay;
			//delayTime = delayTime + 0.05 * m;

			maxDelay = Math.max(maxDelay, delayTime);

			tl3[m].clear();
			tl3[m].add(gsap.to(wantEach[m],
				{
					xPercent: 0,
					opacity: 1,
					duration: 0.6,
					delay: delayTime
				}
			));
			//wantEach.eq(m).css( { transform: "translateX(" + kyori + "%)" } );
		}

		maxDelay = maxDelay * 1000 + 300;

		//console.log(maxDelay);

		setTimeout(function () {
			wantLoop()
		}, maxDelay);
	}

	function wantLoop() {
		tl1.play();
		tl2.play();
	}
	function wantPause() {
		tl1.pause();
		tl2.pause();
	}


	/*--------------------------------
	hover
	--------------------------------*/

	let wantEachBtn = document.querySelectorAll(".wantList li a");

	for (var k = 0; k < wantEachBtn.length; k++) {
		let tmp = wantEachBtn[k];

		//マウスが要素上に入った時
		wantEachBtn[k].addEventListener('mouseover', () => {

			//console.log(tmp);
			let bgNum = tmp.dataset.bg;
			//console.log(bgNum);
			//target.style.background = '#000000';

			document.getElementById(bgNum).classList.add("show");
			
			wantPause();

		}, false);

		//マウスが要素上から離れた時
		wantEachBtn[k].addEventListener('mouseleave', () => {
			let bgNum2 = tmp.dataset.bg;

			document.getElementById(bgNum2).classList.remove("show");
			
			wantLoop();

		}, false);
	}















	let selectedNum = 0;
	let pager = Array.from(document.querySelectorAll(".pager"));

	/*--------------------------------
	scroll
	--------------------------------*/


	const selectedTtl = document.getElementById("selectedTtl");
	const selectedPager = document.getElementById("selectedPager");
	const mask = document.getElementById("mask");

	// 高さの設定は以前 scroll のたびに行っていたが、値はウィンドウの高さで決まるので resize 時だけにする
	// （以前は resize で 1.2 倍、scroll で 1.5 倍を設定しており、実際に効いていたのは 1.5 倍）
	function setHeight() {
		num = target.dataset.height;//stickyBox
		numLong = num * 1.5;
		targetHHH = page.h * numLong - 78 * numLong;

		//長い高さを設定する
		target.style.height = targetHHH + 'px';
	}
	setHeight();
	window.addEventListener('resize', setHeight);

	let ticking = false;

	function update() {
		ticking = false;

		//ターゲットの位置
		targetOff = target.getBoundingClientRect().top + window.pageYOffset;

		//移動できる最大距離
		all = targetHHH - page.h;

		//どれだけ移動した
		sa = page.winScrollTop - targetOff + 78;

		percent = sa / all * 100;

		// 以下はループの外に出しても同じ結果になる処理
		const isStarted = percent >= -10;
		selectedTtl.classList.toggle("show", isStarted);
		mask.classList.toggle("hide", isStarted);

		const isLast = percent >= 100 / num * (num - 1);
		selectedPager.classList.toggle("hide", isLast);
		selectedTtl.classList.toggle("hide", isLast);
		mask.classList.toggle("show", isLast);

		if (percent <= 100) {
			const unit = 100 / num;

			for (var i = 0; i < heightBox.length; i++) {
				let shikiri = unit * i;

				if (percent >= shikiri && percent <= shikiri + unit) {
					heightBox[i].classList.add("active");
					selectedNum = i;

					if (selectedNum >= 0 && selectedNum <= num - 2) {
						pager.forEach((element) => {
							element.classList.remove('on');
						});
						document.getElementById("pager" + selectedNum).classList.add("on");
					}
				} else {
					heightBox[i].classList.remove("active");
				}
			}
		}

		/*--------------------------------
		wantBox
		--------------------------------*/

		if (isLast) {
			if (randomFlg) {
				wantAdjust();
				randomFlg = false;
			}
		} else {
			if (!randomFlg) {
				wantRandom();
				randomFlg = true;
			}
		}
	}

	document.addEventListener('scroll', () => {
		if (!ticking) {
			ticking = true;
			requestAnimationFrame(update);
		}
	}, { passive: true });
}
